import * as React from 'react'
import { cn } from '@/lib/utils'

interface CircularProgressProps {
    value: number
    size?: number
    strokeWidth?: number
    className?: string
    children?: React.ReactNode
}

const CircularProgress = React.forwardRef<
    HTMLDivElement,
    CircularProgressProps
>(({ value, size = 48, strokeWidth = 3, className, children }, ref) => {
    const radius = (size - strokeWidth) / 2
    const circumference = 2 * Math.PI * radius
    const offset =
        circumference -
        (Math.min(100, Math.max(0, value)) / 100) * circumference

    return (
        <div
            ref={ref}
            className={cn(
                'relative inline-flex items-center justify-center shrink-0',
                className
            )}
            style={{ width: size, height: size }}
        >
            <svg
                className="absolute inset-0 -rotate-90"
                width={size}
                height={size}
                viewBox={`0 0 ${size} ${size}`}
                aria-hidden="true"
            >
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    fill="none"
                    strokeWidth={strokeWidth}
                    className="stroke-muted"
                />
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    fill="none"
                    strokeWidth={strokeWidth}
                    strokeDasharray={circumference}
                    strokeDashoffset={offset}
                    strokeLinecap="round"
                    className="stroke-amber-400 transition-all duration-500"
                />
            </svg>
            {children}
        </div>
    )
})
CircularProgress.displayName = 'CircularProgress'

export { CircularProgress }
